export default __webpack_public_path__ + "locales/ko-KR/InviteDialog.json?hash=de40dd825f1b810674bf9057f8bf0686";